<script lang="ts">
import { defineBlock } from '@bagelink/blox'
export const BotFooter = defineBlock({ name: 'BotFooter', label: 'Footer', icon: 'vertical_align_bottom', order: 8, global: true })
</script>
<script setup lang="ts">

import { Btn, Icon } from '@bagelink/vue'</script>

<template>
	<div class="bg-black py-3 m_pb-1 m_bt-2 color-white">
		<div class="w1170px flex space-between  m_column gap-2">
			<RouterLink to="/#hero" class="hover px-2">
				<img src="@/assets/ati-logo-white.svg" alt="Academic Torah Institute" class="h90px m_h90px">
			</RouterLink>
			<div class="border-end h100px m_line m_none" />
			<div class="line w100px none m_block" />

			<div class="flex justify-content-end gap-1-5 m_column">
				<a href="https://www.thetorah.com/" target="_blank" class="hover decoration-none">
					<img src="@/assets/the-torah-white-footer.svg" alt="the torah" class="h25px">
				</a>
				<a href="https://thetorah.co.il/" target="_blank" class="hover decoration-none">
					<img src="@/assets/the-torah-white-he-footer.svg" alt="התורה" class="h25px">
				</a>
				<a href="https://thegemara.com/" target="_blank" class="hover decoration-none">
					<img src="@/assets/the-gemara-white-footer.svg" alt="the gemara" class="h25px">
				</a>
				<div class="flex gap-1">
					<Btn class="color-white px-05" flat target="_blank" href="https://www.facebook.com/AcademicTorahInstitute">
						<Icon size="1.5" name="facebook-f" />
					</Btn>
					<Btn class="color-white px-05" flat target="_blank" href="https://x.com/TheTorahCom">
						<Icon size="1.5" name="x-twitter" />
					</Btn>
				</div>
				<p class="txt12 m_txt-center">
					Launched Shavuot 5773 / 2013
					<br>
					Copyright ©  Academic Torah Institute, All Rights Reserved
				</p>
			</div>
		</div>
	</div>
</template>
